<!--
  Example modal body for the design-system Modal demo. Mirrors the real
  "form in a modal" pattern (PersonnelForm): a field + a roles table with
  checkboxes + Cancel/Save that emit `close` to dismiss the modal.
-->
<template>
  <div class="flex flex-col gap-4">
    <p class="text-subtle">Ange personnummer och välj vilka roller personen ska få.</p>

    <div class="max-w-sm">
      <AppTextField v-model="personalNumber" label="Personnummer" placeholder="198010209999" />
    </div>

    <AppTable>
      <thead>
        <tr>
          <th>Roll</th>
          <th>Beskrivning</th>
          <th>Tilldela</th>
        </tr>
      </thead>
      <tbody>
        <AppTableRow v-for="role in roles" :key="role.key">
          <AppTableCell>{{ role.label }}</AppTableCell>
          <AppTableCell>{{ role.description }}</AppTableCell>
          <AppTableCell action>
            <AppCheckbox v-model="role.checked" :aria-label="`Välj rollen ${role.label}`" />
          </AppTableCell>
        </AppTableRow>
      </tbody>
    </AppTable>

    <div class="flex justify-end gap-2 pt-2">
      <AppButton @click="emit('close')">Avbryt</AppButton>
      <AppButton color="blue" medium @click="emit('close')">Spara personal</AppButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { AppButton, AppCheckbox, AppTable, AppTableCell, AppTableRow, AppTextField } from '@staff/ui'

const emit = defineEmits<{
  (e: 'close'): void
}>()

const personalNumber = ref('')
const roles = ref([
  { key: 'broker', label: 'Handläggare', description: 'Grundbehörighet för samtlig personal', checked: true },
  {
    key: 'personnelManager',
    label: 'Personalansvarig',
    description: 'Rätt att lägga till personal och sätta behörigheter',
    checked: false,
  },
  {
    key: 'pricingAdministrator',
    label: 'Prissättningsansvarig',
    description: 'Rätt att ändra listräntor',
    checked: false,
  },
])
</script>
